/**
 * ISO 3166-1 alpha-2 country codes for the EU-27, plus the EEA (Iceland,
 * Liechtenstein, Norway) and the United Kingdom. This is the broad set most
 * commonly used for age/privacy gating.
 *
 * Codes are matched against Cloudflare's `CF-IPCountry` header, surfaced to the
 * client via the `/geo` route in server.js. Cloudflare uses uppercase codes.
 */
const EU_EEA_UK: ReadonlySet<string> = new Set([
  // EU-27
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
  // EEA (non-EU)
  'IS', 'LI', 'NO',
  // United Kingdom
  'GB',
]);

/**
 * Returns true if the given 2-letter country code is in the EU/EEA/UK set.
 * Case-insensitive; returns false for null/undefined/unknown ("XX") codes.
 */
export function isEuCountry(code: string | null | undefined): boolean {
  if (!code) return false;
  return EU_EEA_UK.has(code.trim().toUpperCase());
}
